import { DonationType, DonationTypeOptions } from "../../types"
import "../../styles/donation-type-toggle.css"

interface DonationTypeSelectorProps {
  activeDonationType: DonationType
  setActiveDonationType: (type: DonationType) => void
}

export default function DonationTypeSelector({
  activeDonationType,
  setActiveDonationType,
}: DonationTypeSelectorProps) {
  return (
    <div
      className="toggle"
      role="group"
      aria-label="Donation type selector"
      key="donation-type-selector"
    >
      {DonationTypeOptions.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`toggle-button ${activeDonationType === option.value ? "active" : ""}`}
          onClick={() => setActiveDonationType(option.value)}
        >
          {option.label}
        </button>
      ))}
      <div
        className="slider"
        style={{
          transform:
            activeDonationType === DonationTypeOptions[1].value
              ? "translateX(100%)"
              : "translateX(0%)",
        }}
      />
    </div>
  )
}
